import {
  MyReferenceField,
  MyReferenceInput,
} from "../../ra-lb-tools/components/myReference";

export const LockerOpenReasonInput = (props) => {
  return <MyReferenceInput reference="locker-open-reasons" {...props} />;
};

export const LockerOpenReasonField = (props) => {
  return (
    <MyReferenceField
      reference="locker-open-reasons"
      className="LockerOpenReasonField"
      {...props}
    />
  );
};
